module.exports = __webpack_public_path__ + "static/media/failure-sound.44db2cdb.wav";